import { RPDF } from '../common/react-pdf';
import React from 'react';

export const ReportLogo: React.FC = () => {
  return (
    <RPDF.Svg width="93" height="16" viewBox="0 0 93 16">
      <RPDF.Path
        d="M16 2.28571C8.42581 2.28571 2.28571 8.42581 2.28571 16H0C0 7.16344 7.16344 0 16 0V2.28571Z"
        fill="#008F8D"
      />
      <RPDF.Path
        d="M16.0001 6.85712C10.9506 6.85712 6.85725 10.9505 6.85725 16H4.57153C4.57153 9.68815 9.68827 4.57141 16.0001 4.57141V6.85712Z"
        fill="#245099"
      />
      <RPDF.Path
        d="M16 11.4285C13.4752 11.4285 11.4285 13.4752 11.4285 16H9.14282C9.14282 12.2129 12.2129 9.14282 16 9.14282V11.4285Z"
        fill="#E4006F"
      />
      <RPDF.Path
        d="M32.6154 13.7692V16H25.967V13.7692H32.6154ZM26.6703 0V16H24V0H26.6703Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M35.2092 0H37.6378L41.3191 11.9011L44.9895 0H47.2422L42.3191 16H40.3081L35.2092 0ZM34.2971 0H36.5389L36.9015 10.1868V16H34.2971V0ZM46.0774 0H48.3301V16H45.7257V10.1868L46.0774 0Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M54.6742 4.46413H53.1781V3.47481H54.6742C54.9179 3.47481 55.1145 3.42282 55.2639 3.31886C55.4166 3.21489 55.5271 3.07193 55.5953 2.88999C55.6668 2.70804 55.7025 2.50173 55.7025 2.27105C55.7025 2.05012 55.6668 1.84218 55.5953 1.64724C55.5271 1.4523 55.4183 1.29473 55.2688 1.17451C55.1193 1.0543 54.9212 0.994195 54.6742 0.994195H53.5095V7.09582H52.3301V0H54.6742C55.1421 0 55.5417 0.0974701 55.8731 0.29241C56.2045 0.48735 56.4579 0.755393 56.6334 1.09654C56.8088 1.43443 56.8966 1.82269 56.8966 2.26131C56.8966 2.71942 56.8088 3.11254 56.6334 3.44069C56.4579 3.76884 56.2045 4.02227 55.8731 4.20096C55.5417 4.37641 55.1421 4.46413 54.6742 4.46413Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M59.6111 0.974701L57.8956 7.09582H56.6577L58.9093 0H59.6793L59.6111 0.974701ZM60.9805 7.09582L59.2602 0.974701L59.1774 0H59.962L62.2233 7.09582H60.9805ZM61.0098 4.45926V5.45345H57.7056V4.45926H61.0098Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M65.0061 0V7.09582H63.8267V0H65.0061ZM66.8141 0V0.994195H62.0381V0H66.8141Z"
        fill="#1F2532"
      />
      <RPDF.Path d="M68.9828 0V7.09582H67.7986V0H68.9828Z" fill="#1F2532" />
      <RPDF.Path
        d="M74.3047 6.1065V7.09582H71.2247V6.1065H74.3047ZM71.5366 0V7.09582H70.3523V0H71.5366ZM73.8905 2.95334V3.92804H71.2247V2.95334H73.8905ZM74.2755 0V0.994195H71.2247V0H74.2755Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M80.0944 0V7.09582H78.9345L76.4296 2.18333V7.09582H75.2843V0H76.4296L78.954 4.94661V0H80.0944Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M83.8665 0V7.09582H82.6871V0H83.8665ZM85.6746 0V0.994195H80.8986V0H85.6746Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M52.7346 8.80671H53.8116L55.4442 14.0847L57.072 8.80671H58.0711L55.8877 15.9025H54.9959L52.7346 8.80671ZM52.3301 8.80671H53.3243L53.4851 13.3244V15.9025H52.3301V8.80671ZM57.5545 8.80671H58.5535V15.9025H57.3985V13.3244L57.5545 8.80671Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M62.4182 9.78141L60.7028 15.9025H59.4649L61.7164 8.80671H62.4865L62.4182 9.78141ZM63.7877 15.9025L62.0673 9.78141L61.9845 8.80671H62.7691L65.0304 15.9025H63.7877ZM63.8169 13.266V14.2602H60.5127V13.266H63.8169Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M70.6496 8.80671V15.9025H69.4897L66.9847 10.99V15.9025H65.8394V8.80671H66.9847L69.5092 13.7533V8.80671H70.6496Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M74.524 9.78141L72.8085 15.9025H71.5707L73.8222 8.80671H74.5922L74.524 9.78141ZM75.8935 15.9025L74.1731 9.78141L74.0903 8.80671H74.8749L77.1362 15.9025H75.8935ZM75.9227 13.266V14.2602H72.6185V13.266H75.9227Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M82.5117 12.262V15.0594C82.424 15.1666 82.2908 15.295 82.1121 15.4444C81.9366 15.5906 81.6994 15.7206 81.4005 15.8343C81.1049 15.9448 80.7312 16 80.2796 16C79.8995 16 79.5518 15.9383 79.2367 15.8148C78.9248 15.6913 78.6567 15.5045 78.4326 15.2544C78.2084 15.0042 78.0362 14.6923 77.916 14.3186C77.7958 13.9418 77.7357 13.4966 77.7357 12.9833V11.7211C77.7357 11.2142 77.7893 10.7724 77.8965 10.3955C78.0069 10.0186 78.1678 9.70506 78.379 9.45488C78.5901 9.20146 78.8468 9.01464 79.149 8.89443C79.4511 8.77097 79.7988 8.70924 80.1919 8.70924C80.689 8.70924 81.1032 8.79696 81.4346 8.97241C81.7693 9.1446 82.0243 9.40128 82.1998 9.74242C82.3785 10.0803 82.4824 10.4929 82.5117 10.9803H81.3567C81.3307 10.6814 81.2738 10.4393 81.1861 10.2541C81.1016 10.0657 80.9798 9.92599 80.8206 9.83502C80.6614 9.74405 80.4567 9.69856 80.2065 9.69856C79.9791 9.69856 79.7842 9.73755 79.6217 9.81552C79.4593 9.8935 79.326 10.0153 79.2221 10.181C79.1181 10.3435 79.0418 10.5514 78.993 10.8048C78.9443 11.0583 78.9199 11.3604 78.9199 11.7113V12.9833C78.9199 13.3407 78.9508 13.6477 79.0125 13.9044C79.0742 14.1611 79.1636 14.3722 79.2806 14.5379C79.4008 14.7004 79.5486 14.8206 79.724 14.8986C79.8995 14.9733 80.0993 15.0107 80.3235 15.0107C80.5444 15.0107 80.7199 14.9879 80.8498 14.9424C80.9798 14.897 81.0805 14.8466 81.152 14.7914C81.2267 14.7329 81.2868 14.6874 81.3323 14.6549V13.1929H80.187V12.262H82.5117Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M87.6873 14.9132V15.9025H84.6073V14.9132H87.6873ZM84.9192 8.80671V15.9025H83.7349V8.80671H84.9192ZM87.2731 11.7601V12.7348H84.6073V11.7601H87.2731ZM87.6581 8.80671V9.8009H84.6073V8.80671H87.6581Z"
        fill="#1F2532"
      />
      <RPDF.Path
        d="M88.6718 8.80671H90.8161C91.284 8.80671 91.6804 8.88793 92.0053 9.05038C92.3302 9.21283 92.5771 9.45326 92.746 9.77166C92.9182 10.0868 93.0043 10.4783 93.0043 10.9462C93.0043 11.3003 92.9507 11.6122 92.8435 11.8819C92.7395 12.1516 92.5885 12.379 92.3903 12.5642C92.1921 12.7461 91.9533 12.8875 91.6739 12.9882L91.3279 13.1782H89.5149L89.51 12.184H90.7869C91.0176 12.184 91.2093 12.1337 91.362 12.033C91.5147 11.9322 91.6284 11.7925 91.7031 11.6138C91.7811 11.4352 91.8201 11.2321 91.8201 11.0047C91.8201 10.761 91.786 10.5498 91.7177 10.3711C91.6495 10.1892 91.5423 10.0495 91.3961 9.95198C91.2499 9.85126 91.0566 9.8009 90.8161 9.8009H89.8561V15.9025H88.6718V8.80671ZM91.976 15.9025L90.6261 12.7153L91.8591 12.7104L93.2431 15.8392V15.9025H91.976Z"
        fill="#1F2532"
      />
    </RPDF.Svg>
  );
};
